(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gallery-carousel"] && !Shopify.designMode) return;
  try {
    
  const initGalleryCarousels = () => {
    document.querySelectorAll('[data-gallery-carousel]').forEach((gallery) => {
      if (gallery.galleryCarouselReady) return;
      gallery.galleryCarouselReady = true;

      const track = gallery.querySelector('[data-gallery-carousel-track]');
      const slides = Array.from(gallery.querySelectorAll('[data-gallery-carousel-slide]'));
      const beforeClones = Array.from(gallery.querySelectorAll('[data-gallery-carousel-clone="before"]'));
      const afterClones = Array.from(gallery.querySelectorAll('[data-gallery-carousel-clone="after"]'));
      const dots = Array.from(gallery.querySelectorAll('[data-gallery-carousel-dot]'));
      const previousButton = gallery.querySelector('[data-gallery-carousel-previous]');
      const nextButton = gallery.querySelector('[data-gallery-carousel-next]');
      const loop = gallery.dataset.loop === 'true';
      const autoplayDuration = (Number(gallery.dataset.autoplaySpeed) || 40) * 1000;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const mobileViewport = window.matchMedia('(max-width: 699px)');
      let activeIndex = 0;
      let scrollFrame;
      let animationFrame;
      let previousFrameTime;
      let autoplayPaused = true;
      let loopWidth = 0;
      let firstSlidePosition = 0;
      let animationPosition = 0;
      let dragStartX = 0;
      let dragStartScroll = 0;
      let dragMoved = false;
      let measured = false;

      if (!track || slides.length < 2) return;

      const autoplayEnabled = () => mobileViewport.matches
        ? gallery.dataset.autoplayMobile === 'true'
        : gallery.dataset.autoplayDesktop === 'true';

      const slidePosition = (slide) => {
        const trackRelativeLeft = slide.offsetLeft - track.offsetLeft;
        if (!mobileViewport.matches) return trackRelativeLeft;
        return trackRelativeLeft - (track.clientWidth - slide.offsetWidth) / 2;
      };

      const measureLoop = (resetPosition = false) => {
        firstSlidePosition = slidePosition(slides[0]);
        loopWidth = afterClones.length
          ? slidePosition(afterClones[0]) - firstSlidePosition
          : Math.max(track.scrollWidth - firstSlidePosition, 0);

        if (!measured || resetPosition) {
          animationPosition = firstSlidePosition;
          track.scrollTo({ left: firstSlidePosition, behavior: 'auto' });
          measured = true;
        } else {
          animationPosition = track.scrollLeft;
        }
      };

      const scrollToIndex = (index, behavior = 'smooth') => {
        activeIndex = Math.max(0, Math.min(index, slides.length - 1));
        animationPosition = slidePosition(slides[activeIndex]);
        track.scrollTo({ left: animationPosition, behavior: autoplayEnabled() ? 'auto' : behavior });
      };

      const normalizeMobileLoop = () => {
        if (!mobileViewport.matches || !loop || !beforeClones.length || !afterClones.length || loopWidth <= 0) return;

        let normalizedPosition = track.scrollLeft;
        if (normalizedPosition < firstSlidePosition) normalizedPosition += loopWidth;
        if (normalizedPosition >= firstSlidePosition + loopWidth) normalizedPosition -= loopWidth;

        if (Math.abs(normalizedPosition - track.scrollLeft) > 1) {
          animationPosition = normalizedPosition;
          track.scrollTo({ left: normalizedPosition, behavior: 'auto' });
        }
      };

      const updateControls = () => {
        const relativeScroll = loop && loopWidth > 0
          ? ((track.scrollLeft - firstSlidePosition) % loopWidth + loopWidth) % loopWidth
          : track.scrollLeft - firstSlidePosition;
        const normalizedScroll = firstSlidePosition + relativeScroll;
        const nearestIndex = slides.reduce((nearest, slide, index) => {
          const currentDistance = Math.abs(slidePosition(slide) - normalizedScroll);
          const nearestDistance = Math.abs(slidePosition(slides[nearest]) - normalizedScroll);
          return currentDistance < nearestDistance ? index : nearest;
        }, 0);

        activeIndex = nearestIndex;
        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          if (isActive) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        if (!loop && !autoplayEnabled()) {
          if (previousButton) previousButton.disabled = track.scrollLeft <= 1;
          if (nextButton) nextButton.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        }
      };

      const animate = (time) => {
        if (!autoplayPaused && loopWidth > 0) {
          const elapsed = previousFrameTime ? Math.min(time - previousFrameTime, 50) : 0;
          const distance = loopWidth * elapsed / autoplayDuration;
          animationPosition += distance;

          if (loop && animationPosition >= firstSlidePosition + loopWidth) animationPosition -= loopWidth;
          if (!loop && animationPosition >= firstSlidePosition + loopWidth - track.clientWidth) {
            animationPosition = firstSlidePosition + loopWidth - track.clientWidth;
            autoplayPaused = true;
          }

          track.scrollLeft = animationPosition;
        }

        previousFrameTime = time;
        animationFrame = window.requestAnimationFrame(animate);
      };

      const stopAutoplay = () => {
        autoplayPaused = true;
      };

      const startAutoplay = () => {
        if (!autoplayEnabled() || reducedMotion || track.scrollWidth <= track.clientWidth) return;
        animationPosition = track.scrollLeft;
        previousFrameTime = performance.now();
        autoplayPaused = false;
        if (!animationFrame) animationFrame = window.requestAnimationFrame(animate);
      };

      previousButton?.addEventListener('click', () => {
        if (mobileViewport.matches && loop && activeIndex <= 0 && beforeClones.length) {
          animationPosition = slidePosition(beforeClones[beforeClones.length - 1]);
          track.scrollTo({ left: animationPosition, behavior: autoplayEnabled() ? 'auto' : 'smooth' });
          startAutoplay();
          return;
        }
        const target = activeIndex <= 0 && loop ? slides.length - 1 : activeIndex - 1;
        scrollToIndex(target);
        startAutoplay();
      });

      nextButton?.addEventListener('click', () => {
        if (mobileViewport.matches && loop && activeIndex >= slides.length - 1 && afterClones.length) {
          animationPosition = slidePosition(afterClones[0]);
          track.scrollTo({ left: animationPosition, behavior: autoplayEnabled() ? 'auto' : 'smooth' });
          startAutoplay();
          return;
        }
        const target = activeIndex >= slides.length - 1 && loop ? 0 : activeIndex + 1;
        scrollToIndex(target);
        startAutoplay();
      });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          scrollToIndex(index);
          startAutoplay();
        });
      });

      track.addEventListener('scroll', () => {
        if (autoplayPaused) animationPosition = track.scrollLeft;
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(updateControls);
      }, { passive: true });

      track.addEventListener('scrollend', () => {
        normalizeMobileLoop();
        updateControls();
      });

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse') return;
        dragStartX = event.clientX;
        dragStartScroll = track.scrollLeft;
        animationPosition = track.scrollLeft;
        dragMoved = false;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
        stopAutoplay();
      });

      track.addEventListener('pointermove', (event) => {
        if (!track.hasPointerCapture(event.pointerId)) return;
        const distance = event.clientX - dragStartX;
        if (Math.abs(distance) > 5) dragMoved = true;
        animationPosition = dragStartScroll - distance;
        track.scrollLeft = animationPosition;
      });

      const finishDrag = (event) => {
        if (!track.hasPointerCapture(event.pointerId)) return;
        track.releasePointerCapture(event.pointerId);
        track.classList.remove('is-dragging');
        normalizeMobileLoop();
        startAutoplay();
      };

      track.addEventListener('pointerup', finishDrag);
      track.addEventListener('pointercancel', finishDrag);
      track.addEventListener('touchstart', stopAutoplay, { passive: true });
      track.addEventListener('touchend', startAutoplay, { passive: true });
      track.addEventListener('click', (event) => {
        if (!dragMoved) return;
        event.preventDefault();
        event.stopPropagation();
        dragMoved = false;
      }, true);

      gallery.addEventListener('mouseenter', stopAutoplay);
      gallery.addEventListener('mouseleave', startAutoplay);
      gallery.addEventListener('focusin', stopAutoplay);
      gallery.addEventListener('focusout', startAutoplay);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      });

      window.addEventListener('resize', () => {
        measureLoop(true);
        scrollToIndex(activeIndex, 'auto');
        updateControls();
      });

      measureLoop(true);
      updateControls();
      startAutoplay();
    });
  };

  const initGalleryCarouselLightbox = () => {
    document.querySelectorAll('[data-gallery-carousel-lightbox]').forEach((lightbox) => {
      if (lightbox.galleryCarouselLightboxReady) return;
      lightbox.galleryCarouselLightboxReady = true;

      const section = lightbox.closest('.section-spacing') || document;
      const image = lightbox.querySelector('[data-gallery-carousel-lightbox-image]');
      const closeButton = lightbox.querySelector('[data-gallery-carousel-lightbox-close]');

      const openLightbox = (src) => {
        image.src = src;
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
      };

      const closeLightbox = () => {
        lightbox.hidden = true;
        image.src = '';
        document.body.style.overflow = '';
      };

      section.querySelectorAll('[data-gallery-carousel-lightbox-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', () => openLightbox(trigger.dataset.full));
      });

      closeButton.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', (event) => {
        if (event.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !lightbox.hidden) closeLightbox();
      });
    });
  };

  initGalleryCarousels();
  initGalleryCarouselLightbox();
  document.addEventListener('shopify:section:load', initGalleryCarousels);
  document.addEventListener('shopify:section:load', initGalleryCarouselLightbox);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gallery-marquee')) {
    customElements.define(
      'gallery-marquee',
      class GalleryMarquee extends HTMLElement {
        connectedCallback() {
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-directory"] && !Shopify.designMode) return;
  try {
    
  const loadStoreDirectoryMapLibre = () => {
    if (window.maplibregl) return Promise.resolve(window.maplibregl);
    if (window.storeDirectoryMapLibrePromise) return window.storeDirectoryMapLibrePromise;

    window.storeDirectoryMapLibrePromise = new Promise((resolve, reject) => {
      if (!document.querySelector('link[data-store-directory-maplibre]')) {
        const stylesheet = document.createElement('link');
        stylesheet.rel = 'stylesheet';
        stylesheet.href = 'https://unpkg.com/maplibre-gl@4.7.1/dist/maplibre-gl.css';
        stylesheet.dataset.storeDirectoryMaplibre = '';
        document.head.appendChild(stylesheet);
      }

      const existingScript = document.querySelector('script[data-store-directory-maplibre]');
      const script = existingScript || document.createElement('script');
      const handleLoad = () => resolve(window.maplibregl);
      const handleError = () => reject(new Error('MapLibre GL could not be loaded'));

      script.addEventListener('load', handleLoad, { once: true });
      script.addEventListener('error', handleError, { once: true });

      if (!existingScript) {
        script.src = 'https://unpkg.com/maplibre-gl@4.7.1/dist/maplibre-gl.js';
        script.dataset.storeDirectoryMaplibre = '';
        document.head.appendChild(script);
      }
    });

    return window.storeDirectoryMapLibrePromise;
  };

  const initStoreDirectoryMaps = () => {
    const mapElements = Array.from(document.querySelectorAll('[data-store-directory-map]')).filter((element) => !element.storeDirectoryMapReady);
    if (!mapElements.length) return;

    const createMap = (element) => {
      if (element.storeDirectoryMapReady) return;
      element.storeDirectoryMapReady = true;

      loadStoreDirectoryMapLibre().then((maplibregl) => {
        const latitude = Number(element.dataset.latitude);
        const longitude = Number(element.dataset.longitude);
        const isMobile = window.matchMedia('(max-width: 699px)').matches;
        const zoom = Number(isMobile ? element.dataset.zoomMobile : element.dataset.zoom) || (isMobile ? 17 : 16);
        const markerWidth = isMobile ? 72 : 98;
        const markerHeight = isMobile ? 107 : 145;
        const directionsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;

        // OpenFreeMap's free, no-API-key "positron" style - the same open-source
        // design CARTO's (now key-gated) Positron/light_all tiles are built from,
        // so this reproduces the site's original pale grey/green map look exactly.
        const map = new maplibregl.Map({
          container: element,
          style: 'https://tiles.openfreemap.org/styles/positron',
          center: [longitude, latitude],
          zoom,
          scrollZoom: false,
          attributionControl: { compact: true }
        });
        map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'top-left');

        const markerEl = document.createElement('img');
        markerEl.src = element.dataset.markerUrl;
        markerEl.alt = '';
        markerEl.style.cssText = `width:${markerWidth}px; height:${markerHeight}px; cursor:pointer;`;
        markerEl.setAttribute('role', 'button');
        markerEl.setAttribute('aria-label', element.dataset.title || '');
        markerEl.addEventListener('click', () => {
          const newWindow = window.open(directionsUrl, '_blank', 'noopener');
          if (newWindow) newWindow.opener = null;
        });
        new maplibregl.Marker({ element: markerEl, anchor: 'bottom' }).setLngLat([longitude, latitude]).addTo(map);

        // The container's layout can still be settling (webfonts, the gallery
        // images above it loading) right as the map initializes - a resize once
        // things have settled keeps the map from rendering at a stale size.
        const resettle = () => {
          map.resize();
          map.setCenter([longitude, latitude]);
        };
        requestAnimationFrame(resettle);
        window.addEventListener('load', resettle, { once: true });
        setTimeout(resettle, 600);

        map.on('load', () => element.classList.add('is-ready'));
      }).catch(() => {});
    };

    if (!('IntersectionObserver' in window)) {
      mapElements.forEach(createMap);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        createMap(entry.target);
      });
    }, { rootMargin: '700px 0px' });

    mapElements.forEach((element) => observer.observe(element));
  };

  const initStoreDirectoryGalleries = () => {
    document.querySelectorAll('[data-store-directory-gallery]').forEach((gallery) => {
      if (gallery.storeDirectoryGalleryReady) return;
      gallery.storeDirectoryGalleryReady = true;

      const track = gallery.querySelector('[data-store-directory-gallery-track]');
      const slides = Array.from(gallery.querySelectorAll('[data-store-directory-gallery-slide]'));
      const beforeClones = Array.from(gallery.querySelectorAll('[data-store-directory-gallery-clone="before"]'));
      const afterClones = Array.from(gallery.querySelectorAll('[data-store-directory-gallery-clone="after"]'));
      const dots = Array.from(gallery.querySelectorAll('[data-store-directory-gallery-dot]'));
      const previousButton = gallery.querySelector('[data-store-directory-gallery-previous]');
      const nextButton = gallery.querySelector('[data-store-directory-gallery-next]');
      const loop = gallery.dataset.loop === 'true';
      const autoplayDuration = (Number(gallery.dataset.autoplaySpeed) || 40) * 1000;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const mobileViewport = window.matchMedia('(max-width: 699px)');
      let activeIndex = 0;
      let scrollFrame;
      let animationFrame;
      let previousFrameTime;
      let autoplayPaused = true;
      let loopWidth = 0;
      let firstSlidePosition = 0;
      let animationPosition = 0;
      let dragStartX = 0;
      let dragStartScroll = 0;
      let dragMoved = false;
      let measured = false;

      if (!track || slides.length < 2) return;

      const autoplayEnabled = () => mobileViewport.matches
        ? gallery.dataset.autoplayMobile === 'true'
        : gallery.dataset.autoplayDesktop === 'true';

      const slidePosition = (slide) => {
        const trackRelativeLeft = slide.offsetLeft - track.offsetLeft;
        if (!mobileViewport.matches) return trackRelativeLeft;
        return trackRelativeLeft - (track.clientWidth - slide.offsetWidth) / 2;
      };

      const measureLoop = (resetPosition = false) => {
        firstSlidePosition = slidePosition(slides[0]);
        loopWidth = afterClones.length
          ? slidePosition(afterClones[0]) - firstSlidePosition
          : Math.max(track.scrollWidth - firstSlidePosition, 0);

        if (!measured || resetPosition) {
          animationPosition = firstSlidePosition;
          track.scrollTo({ left: firstSlidePosition, behavior: 'auto' });
          measured = true;
        } else {
          animationPosition = track.scrollLeft;
        }
      };

      const scrollToIndex = (index, behavior = 'smooth') => {
        activeIndex = Math.max(0, Math.min(index, slides.length - 1));
        animationPosition = slidePosition(slides[activeIndex]);
        track.scrollTo({ left: animationPosition, behavior: autoplayEnabled() ? 'auto' : behavior });
      };

      const normalizeMobileLoop = () => {
        if (!mobileViewport.matches || !loop || !beforeClones.length || !afterClones.length || loopWidth <= 0) return;

        let normalizedPosition = track.scrollLeft;
        if (normalizedPosition < firstSlidePosition) normalizedPosition += loopWidth;
        if (normalizedPosition >= firstSlidePosition + loopWidth) normalizedPosition -= loopWidth;

        if (Math.abs(normalizedPosition - track.scrollLeft) > 1) {
          animationPosition = normalizedPosition;
          track.scrollTo({ left: normalizedPosition, behavior: 'auto' });
        }
      };

      const updateControls = () => {
        const relativeScroll = loop && loopWidth > 0
          ? ((track.scrollLeft - firstSlidePosition) % loopWidth + loopWidth) % loopWidth
          : track.scrollLeft - firstSlidePosition;
        const normalizedScroll = firstSlidePosition + relativeScroll;
        const nearestIndex = slides.reduce((nearest, slide, index) => {
          const currentDistance = Math.abs(slidePosition(slide) - normalizedScroll);
          const nearestDistance = Math.abs(slidePosition(slides[nearest]) - normalizedScroll);
          return currentDistance < nearestDistance ? index : nearest;
        }, 0);

        activeIndex = nearestIndex;
        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          if (isActive) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        if (!loop && !autoplayEnabled()) {
          if (previousButton) previousButton.disabled = track.scrollLeft <= 1;
          if (nextButton) nextButton.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        }
      };

      const animate = (time) => {
        if (!autoplayPaused && loopWidth > 0) {
          const elapsed = previousFrameTime ? Math.min(time - previousFrameTime, 50) : 0;
          const distance = loopWidth * elapsed / autoplayDuration;
          animationPosition += distance;

          if (loop && animationPosition >= firstSlidePosition + loopWidth) animationPosition -= loopWidth;
          if (!loop && animationPosition >= firstSlidePosition + loopWidth - track.clientWidth) {
            animationPosition = firstSlidePosition + loopWidth - track.clientWidth;
            autoplayPaused = true;
          }

          track.scrollLeft = animationPosition;
        }

        previousFrameTime = time;
        animationFrame = window.requestAnimationFrame(animate);
      };

      const stopAutoplay = () => {
        autoplayPaused = true;
      };

      const startAutoplay = () => {
        if (!autoplayEnabled() || reducedMotion || track.scrollWidth <= track.clientWidth) return;
        animationPosition = track.scrollLeft;
        previousFrameTime = performance.now();
        autoplayPaused = false;
        if (!animationFrame) animationFrame = window.requestAnimationFrame(animate);
      };

      previousButton?.addEventListener('click', () => {
        if (mobileViewport.matches && loop && activeIndex <= 0 && beforeClones.length) {
          animationPosition = slidePosition(beforeClones[beforeClones.length - 1]);
          track.scrollTo({ left: animationPosition, behavior: autoplayEnabled() ? 'auto' : 'smooth' });
          startAutoplay();
          return;
        }
        const target = activeIndex <= 0 && loop ? slides.length - 1 : activeIndex - 1;
        scrollToIndex(target);
        startAutoplay();
      });

      nextButton?.addEventListener('click', () => {
        if (mobileViewport.matches && loop && activeIndex >= slides.length - 1 && afterClones.length) {
          animationPosition = slidePosition(afterClones[0]);
          track.scrollTo({ left: animationPosition, behavior: autoplayEnabled() ? 'auto' : 'smooth' });
          startAutoplay();
          return;
        }
        const target = activeIndex >= slides.length - 1 && loop ? 0 : activeIndex + 1;
        scrollToIndex(target);
        startAutoplay();
      });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          scrollToIndex(index);
          startAutoplay();
        });
      });

      track.addEventListener('scroll', () => {
        if (autoplayPaused) animationPosition = track.scrollLeft;
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(updateControls);
      }, { passive: true });

      track.addEventListener('scrollend', () => {
        normalizeMobileLoop();
        updateControls();
      });

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse') return;
        dragStartX = event.clientX;
        dragStartScroll = track.scrollLeft;
        animationPosition = track.scrollLeft;
        dragMoved = false;
        track.classList.add('is-dragging');
        track.setPointerCapture(event.pointerId);
        stopAutoplay();
      });

      track.addEventListener('pointermove', (event) => {
        if (!track.hasPointerCapture(event.pointerId)) return;
        const distance = event.clientX - dragStartX;
        if (Math.abs(distance) > 5) dragMoved = true;
        animationPosition = dragStartScroll - distance;
        track.scrollLeft = animationPosition;
      });

      const finishDrag = (event) => {
        if (!track.hasPointerCapture(event.pointerId)) return;
        track.releasePointerCapture(event.pointerId);
        track.classList.remove('is-dragging');
        normalizeMobileLoop();
        startAutoplay();
      };

      track.addEventListener('pointerup', finishDrag);
      track.addEventListener('pointercancel', finishDrag);
      track.addEventListener('touchstart', stopAutoplay, { passive: true });
      track.addEventListener('touchend', startAutoplay, { passive: true });
      track.addEventListener('click', (event) => {
        if (!dragMoved) return;
        event.preventDefault();
        event.stopPropagation();
        dragMoved = false;
      }, true);

      gallery.addEventListener('mouseenter', stopAutoplay);
      gallery.addEventListener('mouseleave', startAutoplay);
      gallery.addEventListener('focusin', stopAutoplay);
      gallery.addEventListener('focusout', startAutoplay);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      });

      window.addEventListener('resize', () => {
        measureLoop(true);
        scrollToIndex(activeIndex, 'auto');
        updateControls();
      });

      measureLoop(true);
      updateControls();
      startAutoplay();
    });
  };

  const initStoreDirectoryLightbox = () => {
    document.querySelectorAll('[data-store-directory-lightbox]').forEach((lightbox) => {
      if (lightbox.storeDirectoryLightboxReady) return;
      lightbox.storeDirectoryLightboxReady = true;

      const section = lightbox.closest('.section-spacing') || document;
      const image = lightbox.querySelector('[data-store-directory-lightbox-image]');
      const closeButton = lightbox.querySelector('[data-store-directory-lightbox-close]');

      const openLightbox = (src) => {
        image.src = src;
        lightbox.hidden = false;
        document.body.style.overflow = 'hidden';
      };

      const closeLightbox = () => {
        lightbox.hidden = true;
        image.src = '';
        document.body.style.overflow = '';
      };

      section.querySelectorAll('[data-store-directory-lightbox-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', () => openLightbox(trigger.dataset.full));
      });

      closeButton.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', (event) => {
        if (event.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !lightbox.hidden) closeLightbox();
      });
    });
  };

  initStoreDirectoryMaps();
  initStoreDirectoryGalleries();
  initStoreDirectoryLightbox();
  document.addEventListener('shopify:section:load', initStoreDirectoryMaps);
  document.addEventListener('shopify:section:load', initStoreDirectoryGalleries);
  document.addEventListener('shopify:section:load', initStoreDirectoryLightbox);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-menu-header-copytest"] && !Shopify.designMode) return;
  try {
    
  const normalizeStoreMenuText = (value) =>
    String(value || '')
      .toLocaleLowerCase('hu-HU')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '');

  const buildStoreMenuNavigation = () => {
    document.querySelectorAll('[data-store-menu-nav]').forEach((navigation) => {
      navigation.storeMenuAbortController?.abort();
      navigation.storeMenuAbortController = new AbortController();

      const { signal } = navigation.storeMenuAbortController;
      const categoryList = navigation.querySelector('[data-store-menu-nav-list]');
      const catalogList = navigation.querySelector('[data-store-menu-catalog-list]');
      const searchInput = navigation.querySelector('[data-store-menu-search]');
      const emptyState = navigation.querySelector('[data-store-menu-empty]');
      const backButton = navigation.querySelector('[data-store-menu-back]');
      const siteHeader = document.querySelector('.shopify-section-group-header-group.shopify-section--header');
      const defaultCatalog = navigation.dataset.storeMenuDefaultCatalog;
      const categoryStyle = navigation.dataset.storeMenuCategoryStyle || 'cards';
      const allCategoriesLabel = navigation.dataset.storeMenuAllCategories || 'Összes';
      const forceShowCategories = navigation.dataset.storeMenuSingleCategory === 'true';
      const categories = Array.from(document.querySelectorAll('[data-store-menu-category]'));
      const mobileViewport = window.matchMedia('(max-width: 699px)');
      const catalogNames = [
        ...new Set(
          categories.map((category) => category.dataset.storeMenuCatalog || defaultCatalog).filter(Boolean)
        ),
      ];
      let activeCatalog =
        catalogNames.find((catalogName) => catalogName === navigation.dataset.activeCatalog) ||
        (catalogList ? catalogNames[0] : '');
      let activeCategoryId = navigation.dataset.activeCategory || '';
      let catalogBeforeSearch = '';
      let stickyFadeFrame = 0;

      const updateStickyFade = () => {
        const headerBottom = siteHeader?.getBoundingClientRect().bottom || 0;
        const navigationTop = navigation.getBoundingClientRect().top;
        const fadeEdge = Math.max(0, headerBottom - navigationTop);
        const shouldFade =
          !mobileViewport.matches &&
          window.scrollY > 0 &&
          fadeEdge > 18;
        navigation.style.setProperty('--store-menu-site-header-bottom', `${Math.max(0, headerBottom)}px`);
        navigation.style.setProperty('--store-menu-fade-edge', `${fadeEdge}px`);
        navigation.toggleAttribute('data-store-menu-stuck', shouldFade);
      };

      const scheduleStickyFade = () => {
        if (stickyFadeFrame) return;

        stickyFadeFrame = requestAnimationFrame(() => {
          stickyFadeFrame = 0;
          updateStickyFade();
        });
      };

      const renderCatalogButtons = () => {
        if (!catalogList) return;

        catalogList.replaceChildren();

        catalogNames.forEach((catalogName) => {
          const button = document.createElement('button');
          button.className = 'store-menu-nav__catalog';
          button.type = 'button';
          button.textContent = catalogName;
          button.setAttribute('aria-pressed', String(catalogName === activeCatalog));
          button.addEventListener(
            'click',
            () => {
              activeCatalog = catalogName;
              activeCategoryId = '';
              navigation.dataset.activeCatalog = catalogName;
              delete navigation.dataset.activeCategory;
              renderCatalogButtons();
              renderMenu();
            },
            { signal }
          );
          catalogList.append(button);
        });
      };

      const findMatchingCatalog = (query) =>
        catalogNames.find((catalogName) =>
          categories.some((category) => {
            const categoryCatalog = category.dataset.storeMenuCatalog || defaultCatalog;

            if (categoryCatalog !== catalogName) return false;

            return Array.from(category.querySelectorAll('.store-menu-card')).some((card) => {
              const searchText = normalizeStoreMenuText(card.dataset.storeMenuSearch || card.textContent);
              return searchText.includes(query);
            });
          })
        );

      const renderMenu = () => {
        const query = normalizeStoreMenuText(searchInput?.value.trim());
        const isMobile = mobileViewport.matches;
        const usePillStyle = categoryStyle === 'pills' && !isMobile;
        const showMobileProducts = isMobile && !forceShowCategories && Boolean(query || activeCategoryId);
        let visibleCards = 0;

        categoryList?.replaceChildren();

        if (categoryList) {
          categoryList.hidden = showMobileProducts;
        }

        if (backButton) {
          backButton.hidden = !showMobileProducts;
        }

        if (usePillStyle && categoryList) {
          const allButton = document.createElement('button');
          allButton.className = 'store-menu-nav__link';
          allButton.type = 'button';
          allButton.textContent = allCategoriesLabel;
          allButton.setAttribute('aria-pressed', String(!activeCategoryId));
          allButton.addEventListener(
            'click',
            () => {
              activeCategoryId = '';
              delete navigation.dataset.activeCategory;
              renderMenu();
            },
            { signal }
          );
          categoryList.append(allButton);
        }

        categories.forEach((category) => {
          const catalogName = category.dataset.storeMenuCatalog || defaultCatalog;
          const isActiveCatalog = !activeCatalog || catalogName === activeCatalog;
          let isSelectedCategory = true;

          if (usePillStyle) {
            isSelectedCategory = !activeCategoryId || category.id === activeCategoryId;
          } else if (isMobile && !forceShowCategories) {
            isSelectedCategory = Boolean(query) || category.id === activeCategoryId;
          }

          let matchingCategoryCards = 0;

          category.querySelectorAll('.store-menu-card').forEach((card) => {
            const searchText = normalizeStoreMenuText(card.dataset.storeMenuSearch || card.textContent);
            const isMatch = isActiveCatalog && (!query || searchText.includes(query));
            const shouldShow = isMatch && isSelectedCategory;
            card.hidden = !shouldShow;

            if (isMatch) {
              matchingCategoryCards += 1;
            }

            if (shouldShow) {
              visibleCards += 1;
            }
          });

          category.hidden = !isActiveCatalog || matchingCategoryCards === 0 || !isSelectedCategory;

          const title = category.dataset.storeMenuCategory;
          if (isActiveCatalog && matchingCategoryCards > 0 && categoryList && title && category.id) {
            const isFilterButton = isMobile || usePillStyle;
            const link = document.createElement(isFilterButton ? 'button' : 'a');
            link.className = 'store-menu-nav__link';

            if (isFilterButton) {
              link.type = 'button';
              link.setAttribute('aria-controls', category.id);
              link.setAttribute('aria-pressed', String(forceShowCategories || category.id === activeCategoryId));
              link.addEventListener(
                'click',
                () => {
                  activeCategoryId = category.id;
                  navigation.dataset.activeCategory = category.id;
                  renderMenu();
                  if (!usePillStyle) {
                    requestAnimationFrame(() => category.scrollIntoView({ behavior: 'smooth', block: 'start' }));
                  }
                },
                { signal }
              );
            } else {
              link.href = `#${category.id}`;
            }

            const navigationImage = category.dataset.storeMenuNavigationImage;
            if (navigationImage && !usePillStyle && !forceShowCategories) {
              link.style.backgroundImage = `url("${navigationImage.replaceAll('"', '%22')}")`;
            }

            const label = document.createElement('span');
            label.textContent = title;
            link.append(label);
            categoryList.append(link);
          }
        });

        if (emptyState) {
          const isWaitingForCategory = isMobile && !query && !activeCategoryId;
          emptyState.hidden = isWaitingForCategory || visibleCards > 0;
        }
      };

      const handleSearchInput = () => {
        const query = normalizeStoreMenuText(searchInput?.value.trim());

        if (query) {
          catalogBeforeSearch ||= activeCatalog;

          const matchingCatalog = findMatchingCatalog(query);
          if (matchingCatalog && matchingCatalog !== activeCatalog) {
            activeCatalog = matchingCatalog;
            activeCategoryId = '';
            navigation.dataset.activeCatalog = matchingCatalog;
            delete navigation.dataset.activeCategory;
            renderCatalogButtons();
          }
        } else if (catalogBeforeSearch) {
          activeCatalog = catalogBeforeSearch;
          activeCategoryId = '';
          navigation.dataset.activeCatalog = catalogBeforeSearch;
          delete navigation.dataset.activeCategory;
          catalogBeforeSearch = '';
          renderCatalogButtons();
        }

        renderMenu();
      };

      searchInput?.addEventListener('input', handleSearchInput, { signal });
      backButton?.addEventListener(
        'click',
        () => {
          if (searchInput?.value) {
            searchInput.value = '';
            handleSearchInput();
          } else {
            activeCategoryId = '';
            delete navigation.dataset.activeCategory;
            renderMenu();
          }

          requestAnimationFrame(() => navigation.scrollIntoView({ behavior: 'smooth', block: 'start' }));
        },
        { signal }
      );
      mobileViewport.addEventListener(
        'change',
        () => {
          renderMenu();
          scheduleStickyFade();
        },
        { signal }
      );
      window.addEventListener('scroll', scheduleStickyFade, { signal, passive: true });
      window.addEventListener('resize', scheduleStickyFade, { signal, passive: true });
      renderCatalogButtons();
      renderMenu();
      scheduleStickyFade();
    });
  };

  buildStoreMenuNavigation();
  document.addEventListener('shopify:section:load', buildStoreMenuNavigation);
  document.addEventListener('shopify:section:reorder', buildStoreMenuNavigation);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-menu-header"] && !Shopify.designMode) return;
  try {
    
  const normalizeStoreMenuText = (value) =>
    String(value || '')
      .toLocaleLowerCase('hu-HU')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '');

  const buildStoreMenuNavigation = () => {
    document.querySelectorAll('[data-store-menu-nav]').forEach((navigation) => {
      navigation.storeMenuAbortController?.abort();
      navigation.storeMenuAbortController = new AbortController();

      const { signal } = navigation.storeMenuAbortController;
      const categoryList = navigation.querySelector('[data-store-menu-nav-list]');
      const catalogList = navigation.querySelector('[data-store-menu-catalog-list]');
      const searchInput = navigation.querySelector('[data-store-menu-search]');
      const emptyState = navigation.querySelector('[data-store-menu-empty]');
      const backButton = navigation.querySelector('[data-store-menu-back]');
      const siteHeader = document.querySelector('.shopify-section-group-header-group.shopify-section--header');
      const defaultCatalog = navigation.dataset.storeMenuDefaultCatalog;
      const categoryStyle = navigation.dataset.storeMenuCategoryStyle || 'cards';
      const allCategoriesLabel = navigation.dataset.storeMenuAllCategories || 'Összes';
      const forceShowCategories = navigation.dataset.storeMenuSingleCategory === 'true';
      const categories = Array.from(document.querySelectorAll('[data-store-menu-category]'));
      const mobileViewport = window.matchMedia('(max-width: 699px)');
      const catalogNames = [
        ...new Set(
          categories.map((category) => category.dataset.storeMenuCatalog || defaultCatalog).filter(Boolean)
        ),
      ];
      let activeCatalog =
        catalogNames.find((catalogName) => catalogName === navigation.dataset.activeCatalog) ||
        (catalogList ? catalogNames[0] : '');
      let activeCategoryId = navigation.dataset.activeCategory || '';
      let catalogBeforeSearch = '';
      let stickyFadeFrame = 0;

      const updateStickyFade = () => {
        const headerBottom = siteHeader?.getBoundingClientRect().bottom || 0;
        const navigationTop = navigation.getBoundingClientRect().top;
        const fadeEdge = Math.max(0, headerBottom - navigationTop);
        const shouldFade =
          !mobileViewport.matches &&
          window.scrollY > 0 &&
          fadeEdge > 18;
        navigation.style.setProperty('--store-menu-site-header-bottom', `${Math.max(0, headerBottom)}px`);
        navigation.style.setProperty('--store-menu-fade-edge', `${fadeEdge}px`);
        navigation.toggleAttribute('data-store-menu-stuck', shouldFade);
      };

      const scheduleStickyFade = () => {
        if (stickyFadeFrame) return;

        stickyFadeFrame = requestAnimationFrame(() => {
          stickyFadeFrame = 0;
          updateStickyFade();
        });
      };

      const renderCatalogButtons = () => {
        if (!catalogList) return;

        catalogList.replaceChildren();

        catalogNames.forEach((catalogName) => {
          const button = document.createElement('button');
          button.className = 'store-menu-nav__catalog';
          button.type = 'button';
          button.textContent = catalogName;
          button.setAttribute('aria-pressed', String(catalogName === activeCatalog));
          button.addEventListener(
            'click',
            () => {
              activeCatalog = catalogName;
              activeCategoryId = '';
              navigation.dataset.activeCatalog = catalogName;
              delete navigation.dataset.activeCategory;
              renderCatalogButtons();
              renderMenu();
            },
            { signal }
          );
          catalogList.append(button);
        });
      };

      const findMatchingCatalog = (query) =>
        catalogNames.find((catalogName) =>
          categories.some((category) => {
            const categoryCatalog = category.dataset.storeMenuCatalog || defaultCatalog;

            if (categoryCatalog !== catalogName) return false;

            return Array.from(category.querySelectorAll('.store-menu-card')).some((card) => {
              const searchText = normalizeStoreMenuText(card.dataset.storeMenuSearch || card.textContent);
              return searchText.includes(query);
            });
          })
        );

      const renderMenu = () => {
        const query = normalizeStoreMenuText(searchInput?.value.trim());
        const isMobile = mobileViewport.matches;
        const usePillStyle = categoryStyle === 'pills' && !isMobile;
        const showMobileProducts = isMobile && !forceShowCategories && Boolean(query || activeCategoryId);
        let visibleCards = 0;

        categoryList?.replaceChildren();

        if (categoryList) {
          categoryList.hidden = showMobileProducts;
        }

        if (backButton) {
          backButton.hidden = !showMobileProducts;
        }

        if (usePillStyle && categoryList) {
          const allButton = document.createElement('button');
          allButton.className = 'store-menu-nav__link';
          allButton.type = 'button';
          allButton.textContent = allCategoriesLabel;
          allButton.setAttribute('aria-pressed', String(!activeCategoryId));
          allButton.addEventListener(
            'click',
            () => {
              activeCategoryId = '';
              delete navigation.dataset.activeCategory;
              renderMenu();
            },
            { signal }
          );
          categoryList.append(allButton);
        }

        categories.forEach((category) => {
          const catalogName = category.dataset.storeMenuCatalog || defaultCatalog;
          const isActiveCatalog = !activeCatalog || catalogName === activeCatalog;
          let isSelectedCategory = true;

          if (usePillStyle) {
            isSelectedCategory = !activeCategoryId || category.id === activeCategoryId;
          } else if (isMobile && !forceShowCategories) {
            isSelectedCategory = Boolean(query) || category.id === activeCategoryId;
          }

          let matchingCategoryCards = 0;

          category.querySelectorAll('.store-menu-card').forEach((card) => {
            const searchText = normalizeStoreMenuText(card.dataset.storeMenuSearch || card.textContent);
            const isMatch = isActiveCatalog && (!query || searchText.includes(query));
            const shouldShow = isMatch && isSelectedCategory;
            card.hidden = !shouldShow;

            if (isMatch) {
              matchingCategoryCards += 1;
            }

            if (shouldShow) {
              visibleCards += 1;
            }
          });

          category.hidden = !isActiveCatalog || matchingCategoryCards === 0 || !isSelectedCategory;

          const title = category.dataset.storeMenuCategory;
          if (isActiveCatalog && matchingCategoryCards > 0 && categoryList && title && category.id) {
            const isFilterButton = isMobile || usePillStyle;
            const link = document.createElement(isFilterButton ? 'button' : 'a');
            link.className = 'store-menu-nav__link';

            if (isFilterButton) {
              link.type = 'button';
              link.setAttribute('aria-controls', category.id);
              link.setAttribute('aria-pressed', String(forceShowCategories || category.id === activeCategoryId));
              link.addEventListener(
                'click',
                () => {
                  activeCategoryId = category.id;
                  navigation.dataset.activeCategory = category.id;
                  renderMenu();
                  if (!usePillStyle) {
                    requestAnimationFrame(() => category.scrollIntoView({ behavior: 'smooth', block: 'start' }));
                  }
                },
                { signal }
              );
            } else {
              link.href = `#${category.id}`;
            }

            const navigationImage = category.dataset.storeMenuNavigationImage;
            if (navigationImage && !usePillStyle && !forceShowCategories) {
              link.style.backgroundImage = `url("${navigationImage.replaceAll('"', '%22')}")`;
            }

            const label = document.createElement('span');
            label.textContent = title;
            link.append(label);
            categoryList.append(link);
          }
        });

        if (emptyState) {
          const isWaitingForCategory = isMobile && !query && !activeCategoryId;
          emptyState.hidden = isWaitingForCategory || visibleCards > 0;
        }
      };

      const handleSearchInput = () => {
        const query = normalizeStoreMenuText(searchInput?.value.trim());

        if (query) {
          catalogBeforeSearch ||= activeCatalog;

          const matchingCatalog = findMatchingCatalog(query);
          if (matchingCatalog && matchingCatalog !== activeCatalog) {
            activeCatalog = matchingCatalog;
            activeCategoryId = '';
            navigation.dataset.activeCatalog = matchingCatalog;
            delete navigation.dataset.activeCategory;
            renderCatalogButtons();
          }
        } else if (catalogBeforeSearch) {
          activeCatalog = catalogBeforeSearch;
          activeCategoryId = '';
          navigation.dataset.activeCatalog = catalogBeforeSearch;
          delete navigation.dataset.activeCategory;
          catalogBeforeSearch = '';
          renderCatalogButtons();
        }

        renderMenu();
      };

      searchInput?.addEventListener('input', handleSearchInput, { signal });
      backButton?.addEventListener(
        'click',
        () => {
          if (searchInput?.value) {
            searchInput.value = '';
            handleSearchInput();
          } else {
            activeCategoryId = '';
            delete navigation.dataset.activeCategory;
            renderMenu();
          }

          requestAnimationFrame(() => navigation.scrollIntoView({ behavior: 'smooth', block: 'start' }));
        },
        { signal }
      );
      mobileViewport.addEventListener(
        'change',
        () => {
          renderMenu();
          scheduleStickyFade();
        },
        { signal }
      );
      window.addEventListener('scroll', scheduleStickyFade, { signal, passive: true });
      window.addEventListener('resize', scheduleStickyFade, { signal, passive: true });
      renderCatalogButtons();
      renderMenu();
      scheduleStickyFade();
    });
  };

  buildStoreMenuNavigation();
  document.addEventListener('shopify:section:load', buildStoreMenuNavigation);
  document.addEventListener('shopify:section:reorder', buildStoreMenuNavigation);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-article"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('story-article-carousel')) {
    customElements.define(
      'story-article-carousel',
      class StoryArticleCarousel extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;

          this.dataset.initialized = 'true';
          this.track = this.querySelector('.story-article__carousel-track');
          this.slides = Array.from(this.querySelectorAll('[data-story-article-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-story-article-dot]'));
          this.delay = Number(this.dataset.delay) || 5000;
          this.speed = Number(this.dataset.speed) || 3000;
          this.autoplay = this.dataset.autoplay === 'true';
          this.index = this.slides.length > 1 ? 1 : 0;
          this.dragStart = null;
          this.dragged = false;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (!this.track || this.slides.length < 2) return;

          const firstClone = this.slides[0].cloneNode(true);
          const lastClone = this.slides[this.slides.length - 1].cloneNode(true);
          firstClone.removeAttribute('data-story-article-slide');
          lastClone.removeAttribute('data-story-article-slide');
          firstClone.setAttribute('aria-hidden', 'true');
          lastClone.setAttribute('aria-hidden', 'true');
          this.track.prepend(lastClone);
          this.track.append(firstClone);
          this.setPosition(false);

          this.onTransitionEnd = this.handleTransitionEnd.bind(this);
          this.onPointerDown = this.handlePointerDown.bind(this);
          this.onPointerUp = this.handlePointerUp.bind(this);
          this.onClick = this.handleClick.bind(this);
          this.onVisibilityChange = this.handleVisibilityChange.bind(this);

          this.track.addEventListener('transitionend', this.onTransitionEnd);
          this.addEventListener('pointerdown', this.onPointerDown);
          this.addEventListener('pointerup', this.onPointerUp);
          this.addEventListener('pointercancel', this.onPointerUp);
          this.addEventListener('click', this.onClick);
          document.addEventListener('visibilitychange', this.onVisibilityChange);

          this.resizeObserver = new ResizeObserver(() => this.setPosition(false));
          this.resizeObserver.observe(this);

          this.dots.forEach((dot) => {
            dot.addEventListener('click', () => this.goTo(Number(dot.dataset.storyArticleDot) + 1));
          });

          this.schedule();
        }

        disconnectedCallback() {
          window.clearTimeout(this.timer);
          if (!this.track) return;

          this.track.removeEventListener('transitionend', this.onTransitionEnd);
          this.removeEventListener('pointerdown', this.onPointerDown);
          this.removeEventListener('pointerup', this.onPointerUp);
          this.removeEventListener('pointercancel', this.onPointerUp);
          this.removeEventListener('click', this.onClick);
          document.removeEventListener('visibilitychange', this.onVisibilityChange);
          this.resizeObserver?.disconnect();
        }

        setPosition(animate = true) {
          this.track.style.transition = animate && !this.reducedMotion
            ? `transform ${this.speed}ms ease`
            : 'none';
          this.track.style.transform = `translate3d(-${this.index * this.clientWidth}px, 0, 0)`;
        }

        goTo(index) {
          window.clearTimeout(this.timer);
          this.index = index;
          this.setPosition(true);
          this.updateDots();

          if (this.reducedMotion) this.handleTransitionEnd();
        }

        next() {
          this.goTo(this.index + 1);
        }

        previous() {
          this.goTo(this.index - 1);
        }

        handleTransitionEnd(event) {
          if (event && event.target !== this.track) return;

          if (this.index === this.slides.length + 1) {
            this.index = 1;
            this.setPosition(false);
          } else if (this.index === 0) {
            this.index = this.slides.length;
            this.setPosition(false);
          }

          this.updateDots();
          this.schedule();
        }

        updateDots() {
          let activeIndex = this.index - 1;
          if (this.index === 0) activeIndex = this.slides.length - 1;
          if (this.index === this.slides.length + 1) activeIndex = 0;

          this.dots.forEach((dot, dotIndex) => {
            dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false');
          });
        }

        schedule() {
          window.clearTimeout(this.timer);
          if (!document.hidden && this.autoplay) {
            this.timer = window.setTimeout(() => this.next(), this.delay);
          }
        }

        handlePointerDown(event) {
          this.dragStart = event.clientX;
          this.dragged = false;
        }

        handlePointerUp(event) {
          if (this.dragStart === null) return;
          const distance = event.clientX - this.dragStart;
          this.dragStart = null;

          if (Math.abs(distance) < 40) return;
          this.dragged = true;
          distance < 0 ? this.next() : this.previous();
        }

        handleClick(event) {
          if (!this.dragged) return;
          event.preventDefault();
          this.dragged = false;
        }

        handleVisibilityChange() {
          if (document.hidden) {
            window.clearTimeout(this.timer);
          } else {
            this.schedule();
          }
        }
      }
    );
  }

  if (!customElements.get('story-article')) {
    customElements.define(
      'story-article',
      class StoryArticle extends HTMLElement {
        connectedCallback() {
          this.rail = this.querySelector('.story-article__rail');
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.initializeWhenReady();
        }

        disconnectedCallback() {
          window.clearTimeout(this.libraryTimer);
          this.gsapContext?.revert();
        }

        initializeWhenReady(attempt = 0) {
          if (window.gsap && window.ScrollTrigger) {
            this.initializeGsap();
            return;
          }

          if (attempt < 40) {
            this.libraryTimer = window.setTimeout(() => this.initializeWhenReady(attempt + 1), 50);
          }
        }

        initializeGsap() {
          if (!this.rail || this.reducedMotion) return;

          const gsap = window.gsap;
          const ScrollTrigger = window.ScrollTrigger;
          gsap.registerPlugin(ScrollTrigger);

          this.gsapContext = gsap.context(() => {
            gsap.fromTo(
              this,
              { '--story-article-progress': 0 },
              {
                '--story-article-progress': 1,
                ease: 'none',
                scrollTrigger: {
                  trigger: this,
                  start: 'top 80%',
                  end: 'bottom 55%',
                  scrub: 0.5
                }
              }
            );
          }, this);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-timeline-horizontal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('story-timeline-horizontal')) {
    customElements.define(
      'story-timeline-horizontal',
      class StoryTimelineHorizontal extends HTMLElement {
        connectedCallback() {
          this.scroller = this.querySelector('[data-story-timeline-scroller]');
          this.steps = [...this.querySelectorAll('[data-story-h-step]')];
          this.progress = this.querySelector('.story-timeline-h__progress');
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.mobileViewport = window.matchMedia('(max-width: 749px)');
          this.activeIndex = null;
          this.isHovered = false;
          this.startX = 0;
          this.startScrollLeft = 0;

          if (!this.scroller || !this.steps.length) return;

          this.handleScroll = () => this.requestUpdate();
          this.handleResize = () => this.requestUpdate();
          this.handlePointerDown = (event) => this.startDrag(event);
          this.handlePointerMove = (event) => this.drag(event);
          this.handlePointerEnd = (event) => this.finishDrag(event);
          this.handleWheel = (event) => this.scrollWithWheel(event);
          this.handleMobileViewportChange = () => this.initializeMobileStack();
          this.handleMouseEnter = () => { this.isHovered = true; };
          this.handleMouseLeave = () => { this.isHovered = false; };
          this.preventNativeDrag = (event) => event.preventDefault();

          this.scroller.addEventListener('scroll', this.handleScroll, { passive: true });
          this.scroller.addEventListener('pointerdown', this.handlePointerDown);
          this.scroller.addEventListener('pointermove', this.handlePointerMove);
          this.scroller.addEventListener('pointerup', this.handlePointerEnd);
          this.scroller.addEventListener('pointercancel', this.handlePointerEnd);
          this.addEventListener('mouseenter', this.handleMouseEnter);
          this.addEventListener('mouseleave', this.handleMouseLeave);
          document.addEventListener('wheel', this.handleWheel, { passive: false, capture: true });
          this.scroller.addEventListener('dragstart', this.preventNativeDrag);
          this.mobileViewport.addEventListener('change', this.handleMobileViewportChange);
          window.addEventListener('resize', this.handleResize);

          if (!this.reducedMotion) this.classList.add('is-enhanced');
          this.activate(this.steps[0], 0);
          this.initializeMobileStack();
          this.requestUpdate();
        }

        disconnectedCallback() {
          window.cancelAnimationFrame(this.updateFrame);
          this.scroller?.removeEventListener('scroll', this.handleScroll);
          this.scroller?.removeEventListener('pointerdown', this.handlePointerDown);
          this.scroller?.removeEventListener('pointermove', this.handlePointerMove);
          this.scroller?.removeEventListener('pointerup', this.handlePointerEnd);
          this.scroller?.removeEventListener('pointercancel', this.handlePointerEnd);
          this.removeEventListener('mouseenter', this.handleMouseEnter);
          this.removeEventListener('mouseleave', this.handleMouseLeave);
          document.removeEventListener('wheel', this.handleWheel, { capture: true });
          this.scroller?.removeEventListener('dragstart', this.preventNativeDrag);
          this.mobileViewport?.removeEventListener('change', this.handleMobileViewportChange);
          window.removeEventListener('resize', this.handleResize);
          this.mobileObserver?.disconnect();
        }

        isMobileStack() {
          return this.mobileViewport.matches && this.classList.contains('story-timeline-h--mobile-stack');
        }

        initializeMobileStack() {
          this.mobileObserver?.disconnect();

          if (!this.isMobileStack() || this.reducedMotion || !('IntersectionObserver' in window)) {
            return;
          }

          this.mobileObserver = new IntersectionObserver(
            (entries) => {
              const visibleEntries = entries
                .filter((entry) => entry.isIntersecting)
                .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

              if (!visibleEntries.length) return;

              const step = visibleEntries[0].target;
              this.activate(step, this.steps.indexOf(step));
            },
            {
              rootMargin: '-32% 0px -48% 0px',
              threshold: [0, .25, .5, .75, 1]
            }
          );

          this.steps.forEach((step) => this.mobileObserver.observe(step));
        }

        requestUpdate() {
          window.cancelAnimationFrame(this.updateFrame);
          this.updateFrame = window.requestAnimationFrame(() => this.updateFromScroll());
        }

        updateFromScroll() {
          if (this.isMobileStack()) return;

          const maxScroll = Math.max(this.scroller.scrollWidth - this.scroller.clientWidth, 0);
          const scrollProgress = maxScroll > 0 ? this.scroller.scrollLeft / maxScroll : 0;
          const normalizedProgress = Math.min(1, Math.max(0, scrollProgress));
          const visualProgress = .03 + normalizedProgress * .97;
          const targetIndex = Math.round(normalizedProgress * (this.steps.length - 1));

          this.style.setProperty('--story-h-progress', visualProgress);
          this.activate(this.steps[targetIndex], targetIndex);
        }

        activate(activeStep, activeIndex) {
          if (!activeStep || this.activeIndex === activeIndex) return;
          this.activeIndex = activeIndex;

          this.steps.forEach((step) => {
            const isActive = step === activeStep;
            step.classList.toggle('is-active', isActive);
            if (isActive) step.setAttribute('aria-current', 'step');
            else step.removeAttribute('aria-current');
          });

          if (this.isMobileStack()) {
            const progress = (activeIndex + 1) / this.steps.length;
            this.style.setProperty('--story-h-mobile-progress', progress);
          }
        }

        startDrag(event) {
          if (this.isMobileStack() || event.pointerType !== 'mouse' || event.button !== 0) return;
          event.preventDefault();
          this.startX = event.clientX;
          this.startScrollLeft = this.scroller.scrollLeft;
          this.scroller.classList.add('is-dragging');
          this.scroller.setPointerCapture(event.pointerId);
        }

        drag(event) {
          if (!this.scroller.hasPointerCapture(event.pointerId)) return;
          event.preventDefault();
          this.scroller.scrollLeft = this.startScrollLeft - (event.clientX - this.startX);
        }

        scrollWithWheel(event) {
          if (this.isMobileStack()) return;

          const bounds = this.getBoundingClientRect();
          const pointerIsInside = event.clientX >= bounds.left
            && event.clientX <= bounds.right
            && event.clientY >= bounds.top
            && event.clientY <= bounds.bottom;

          if (!this.isHovered && !pointerIsInside) return;

          const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
          const rawDelta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
          const deltaMultiplier = event.deltaMode === 1 ? 32 : event.deltaMode === 2 ? this.scroller.clientWidth : 1;
          const delta = rawDelta * deltaMultiplier;
          const canMoveBackward = delta < 0 && this.scroller.scrollLeft > 0;
          const canMoveForward = delta > 0 && this.scroller.scrollLeft < maxScroll;

          if (!canMoveBackward && !canMoveForward) return;

          event.preventDefault();
          this.scroller.scrollLeft += delta;
        }

        finishDrag(event) {
          if (!this.scroller.hasPointerCapture(event.pointerId)) return;
          this.scroller.releasePointerCapture(event.pointerId);
          this.scroller.classList.remove('is-dragging');
        }
      }
    );
  }

  if (!customElements.get('story-timeline')) {
    customElements.define(
      'story-timeline',
      class StoryTimeline extends HTMLElement {
        connectedCallback() {
          this.steps = [...this.querySelectorAll('[data-story-step]')];
          this.activeYear = this.querySelector('.story-timeline__active-year');
          this.progress = this.querySelector('.story-timeline__progress');
          this.stepsContainer = this.querySelector('.story-timeline__steps');
          this.toggleButton = this.querySelector('[data-story-toggle]');
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.handleToggle = () => this.toggle();
          this.toggleButton?.addEventListener('click', this.handleToggle);

          if (!this.steps.length) return;

          this.activate(this.steps[0], 0);
          this.initializeWhenReady();
        }

        disconnectedCallback() {
          window.clearTimeout(this.libraryTimer);
          window.clearTimeout(this.stepTimer);
          window.clearTimeout(this.toggleTimer);
          this.toggleButton?.removeEventListener('click', this.handleToggle);
          this.gsapContext?.revert();
          this.observer?.disconnect();
        }

        toggle() {
          const isOpen = this.classList.toggle('is-open');
          this.toggleButton?.setAttribute('aria-expanded', String(isOpen));

          window.clearTimeout(this.toggleTimer);
          this.toggleTimer = window.setTimeout(() => window.ScrollTrigger?.refresh(), 560);
        }

        initializeWhenReady(attempt = 0) {
          if (window.gsap && window.ScrollTrigger && !this.reducedMotion) {
            this.initializeGsap();
            return;
          }

          if (!this.reducedMotion && attempt < 40) {
            this.libraryTimer = window.setTimeout(() => this.initializeWhenReady(attempt + 1), 50);
            return;
          }

          this.initializeFallback();
        }

        initializeGsap() {
          const gsap = window.gsap;
          const ScrollTrigger = window.ScrollTrigger;
          gsap.registerPlugin(ScrollTrigger);

          this.usingGsap = true;
          this.classList.add('is-enhanced');
          this.activeIndex = null;

          this.gsapContext = gsap.context(() => {
            gsap.set(this.progress, { scaleY: 0, transformOrigin: 'top center' });

            this.progressTween = gsap.to(this.progress, {
              scaleY: 1,
              ease: 'none',
              onUpdate: () => this.activateFromProgress(this.progressTween?.progress() || 0),
              scrollTrigger: {
                trigger: this.steps[0].querySelector('.story-timeline__year') || this.steps[0],
                start: 'center 55%',
                endTrigger:
                  this.steps[this.steps.length - 1].querySelector('.story-timeline__year') ||
                  this.steps[this.steps.length - 1],
                end: 'center 90%',
                scrub: 0.65
              }
            });
          }, this);

          window.requestAnimationFrame(() => {
            ScrollTrigger.refresh();
            this.activateFromProgress(this.progressTween?.progress() || 0);
          });
        }

        initializeFallback() {
          if (!('IntersectionObserver' in window)) return;

          this.classList.add('is-enhanced');
          this.observer = new IntersectionObserver(
            (entries) => {
              const visibleEntries = entries
                .filter((entry) => entry.isIntersecting)
                .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

              if (!visibleEntries.length) return;

              const step = visibleEntries[0].target;
              this.activate(step, this.steps.indexOf(step));
            },
            {
              rootMargin: '-32% 0px -48% 0px',
              threshold: [0, .25, .5, .75, 1]
            }
          );

          this.steps.forEach((step) => this.observer.observe(step));
        }

        activateFromProgress(progress) {
          const normalizedProgress = Math.min(1, Math.max(0, progress));
          this.targetIndex = Math.round(normalizedProgress * (this.steps.length - 1));

          if (this.activeIndex === null || this.activeIndex === undefined) {
            this.activate(this.steps[this.targetIndex], this.targetIndex);
            return;
          }

          this.stepTowardTarget();
        }

        stepTowardTarget() {
          if (this.stepTimer || this.activeIndex === this.targetIndex) return;

          const direction = this.targetIndex > this.activeIndex ? 1 : -1;
          const nextIndex = this.activeIndex + direction;
          this.activate(this.steps[nextIndex], nextIndex);

          this.stepTimer = window.setTimeout(() => {
            this.stepTimer = null;
            this.stepTowardTarget();
          }, 110);
        }

        activate(activeStep, activeIndex) {
          if (this.activeIndex === activeIndex) return;

          this.activeIndex = activeIndex;
          this.steps.forEach((step) => {
            const isActive = step === activeStep;
            step.classList.toggle('is-active', isActive);
            if (isActive) step.setAttribute('aria-current', 'step');
            else step.removeAttribute('aria-current');
          });

          if (this.activeYear) {
            if (this.usingGsap) {
              window.gsap.killTweensOf(this.activeYear);
              this.activeYear.textContent = activeStep.dataset.year;
              window.gsap.fromTo(
                this.activeYear,
                { opacity: 0, y: 8 },
                { opacity: 1, y: 0, duration: 0.28, ease: 'power2.out', overwrite: true }
              );
            } else {
              this.activeYear.textContent = activeStep.dataset.year;
            }
          }

          if (this.progress && !this.usingGsap) {
            const progress = (activeIndex + 1) / this.steps.length;
            this.progress.style.setProperty('--story-progress', progress);
          }

          if (this.usingGsap) {
            this.steps.forEach((step) => {
              const isActive = step === activeStep;
              window.gsap.to(step, {
                opacity: isActive ? 1 : 0.52,
                y: isActive ? 0 : 12,
                duration: 0.42,
                ease: 'power2.out',
                overwrite: true
              });
            });
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('story-timeline')) {
    customElements.define(
      'story-timeline',
      class StoryTimeline extends HTMLElement {
        connectedCallback() {
          this.steps = [...this.querySelectorAll('[data-story-step]')];
          this.activeYear = this.querySelector('.story-timeline__active-year');
          this.progress = this.querySelector('.story-timeline__progress');
          this.stepsContainer = this.querySelector('.story-timeline__steps');
          this.toggleButton = this.querySelector('[data-story-toggle]');
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.handleToggle = () => this.toggle();
          this.toggleButton?.addEventListener('click', this.handleToggle);

          if (!this.steps.length) {
            return;
          }

          this.activate(this.steps[0], 0);
          this.initializeWhenReady();
        }

        disconnectedCallback() {
          window.clearTimeout(this.libraryTimer);
          window.clearTimeout(this.stepTimer);
          window.clearTimeout(this.toggleTimer);
          this.toggleButton?.removeEventListener('click', this.handleToggle);
          this.gsapContext?.revert();
          this.observer?.disconnect();
        }

        toggle() {
          const isOpen = this.classList.toggle('is-open');
          this.toggleButton?.setAttribute('aria-expanded', String(isOpen));

          window.clearTimeout(this.toggleTimer);
          this.toggleTimer = window.setTimeout(() => {
            window.ScrollTrigger?.refresh();
          }, 560);
        }

        initializeWhenReady(attempt = 0) {
          if (window.gsap && window.ScrollTrigger && !this.reducedMotion) {
            this.initializeGsap();
            return;
          }

          if (!this.reducedMotion && attempt < 40) {
            this.libraryTimer = window.setTimeout(() => this.initializeWhenReady(attempt + 1), 50);
            return;
          }

          this.initializeFallback();
        }

        initializeGsap() {
          const gsap = window.gsap;
          const ScrollTrigger = window.ScrollTrigger;
          gsap.registerPlugin(ScrollTrigger);

          this.usingGsap = true;
          this.classList.add('is-enhanced');
          this.activeIndex = null;

          this.gsapContext = gsap.context(() => {
            gsap.set(this.progress, {
              scaleY: 0,
              transformOrigin: 'top center'
            });

            this.progressTween = gsap.to(this.progress, {
              scaleY: 1,
              ease: 'none',
              onUpdate: () => this.activateFromProgress(this.progressTween?.progress() || 0),
              scrollTrigger: {
                trigger: this.steps[0].querySelector('.story-timeline__year') || this.steps[0],
                start: 'center 55%',
                endTrigger:
                  this.steps[this.steps.length - 1].querySelector('.story-timeline__year') ||
                  this.steps[this.steps.length - 1],
                end: 'center 90%',
                scrub: 0.65
              }
            });
          }, this);

          window.requestAnimationFrame(() => {
            ScrollTrigger.refresh();
            this.activateFromProgress(this.progressTween?.progress() || 0);
          });
        }

        initializeFallback() {
          if (!('IntersectionObserver' in window)) {
            return;
          }

          this.classList.add('is-enhanced');
          this.observer = new IntersectionObserver(
            (entries) => {
              const visibleEntries = entries
                .filter((entry) => entry.isIntersecting)
                .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

              if (!visibleEntries.length) {
                return;
              }

              const step = visibleEntries[0].target;
              this.activate(step, this.steps.indexOf(step));
            },
            {
              rootMargin: '-32% 0px -48% 0px',
              threshold: [0, .25, .5, .75, 1]
            }
          );

          this.steps.forEach((step) => this.observer.observe(step));
        }

        activateFromProgress(progress) {
          const normalizedProgress = Math.min(1, Math.max(0, progress));
          this.targetIndex = Math.round(normalizedProgress * (this.steps.length - 1));

          if (this.activeIndex === null || this.activeIndex === undefined) {
            this.activate(this.steps[this.targetIndex], this.targetIndex);
            return;
          }

          this.stepTowardTarget();
        }

        stepTowardTarget() {
          if (this.stepTimer || this.activeIndex === this.targetIndex) {
            return;
          }

          const direction = this.targetIndex > this.activeIndex ? 1 : -1;
          const nextIndex = this.activeIndex + direction;
          this.activate(this.steps[nextIndex], nextIndex);

          this.stepTimer = window.setTimeout(() => {
            this.stepTimer = null;
            this.stepTowardTarget();
          }, 110);
        }

        activate(activeStep, activeIndex) {
          if (this.activeIndex === activeIndex) {
            return;
          }

          this.activeIndex = activeIndex;

          this.steps.forEach((step) => {
            const isActive = step === activeStep;
            step.classList.toggle('is-active', isActive);

            if (isActive) {
              step.setAttribute('aria-current', 'step');
            } else {
              step.removeAttribute('aria-current');
            }
          });

          if (this.activeYear) {
            if (this.usingGsap) {
              window.gsap.killTweensOf(this.activeYear);
              this.activeYear.textContent = activeStep.dataset.year;
              window.gsap.fromTo(
                this.activeYear,
                { opacity: 0, y: 8 },
                { opacity: 1, y: 0, duration: 0.28, ease: 'power2.out', overwrite: true }
              );
            } else {
              this.activeYear.textContent = activeStep.dataset.year;
            }
          }

          if (this.progress && !this.usingGsap) {
            const progress = (activeIndex + 1) / this.steps.length;
            this.progress.style.setProperty('--story-progress', progress);
          }

          if (this.usingGsap) {
            this.steps.forEach((step) => {
              const isActive = step === activeStep;
              const card = step.querySelector('.story-timeline__card');

              window.gsap.to(step, {
                y: isActive ? 0 : 12,
                duration: 0.42,
                ease: 'power2.out',
                overwrite: true
              });

              if (card) {
                window.gsap.to(card, {
                  opacity: isActive ? 1 : 0.52,
                  duration: 0.42,
                  ease: 'power2.out',
                  overwrite: true
                });
              }
            });
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
